import React from 'react';
import {observer} from 'mobx-react';
import styles from "../../styles/competitor-players-stats-module.module.scss";
import classNames from "classnames";
import {AthletePropositionBetModuleAsync} from "../../../athlete-proposition-bet-module/components/athlete-proposition-bet-module.async";

export const CompetitorPlayersStatsModulePlayerPropsBet = observer(({controller, gameId}) => {
  const {state} = controller;
  const {selectedAthleteId} = state;

  const propsBetProps = {
    gameId,
    athleteId: selectedAthleteId
  }

  return (
    <div className={classNames(styles.props_container)}>
      <AthletePropositionBetModuleAsync {...propsBetProps}/>
    </div>
  )
})
